export const elementIDs = {
  products: "products",
  downloads: "downloads",
  stories: "stories",
  videoStories: "video-stories",
};
